export default __webpack_public_path__ + "15c7521fabe15fc66cc4c3f666fb12a6.woff2";